@if (package$ | async; as pkg) {
  <div class="layout-col full bg-background">
    <!-- Header Section -->
    <div class="layout-row">
      @if (!embedded) {
        <mat-toolbar elderTheme color="primary" class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ pkg: pkg, frm: mainFrm }"
          ></ng-template>
        </mat-toolbar>
      } @else {
        <div class="layout-row place-start-center gap-md flex p-md">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ pkg: pkg, frm: mainFrm }"
          ></ng-template>
        </div>
      }
    </div>
    <!-- Content -->
    <form #mainFrm="ngForm" class="layout-row flex">
      <elder-basic-pane-layout class="flex">
        <elder-pane class="layout-col flex-40">
          <elder-pane-header>
            <elder-pane-title>{{ 'packages.title' | translate }}</elder-pane-title>
          </elder-pane-header>
          <elder-pane-content>
            <div>
              <elder-pane-subtitle>{{ 'context.identification' | translate }}</elder-pane-subtitle>
              <div class="layout-col gap-md">
                <div class="layout-row gap-md">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'storageGroups.storageGroup' | translate }}</mat-label>
                    <input
                      matInput
                      name="storageGroupId"
                      required
                      [ngModel]="pkg.storageGroupId"
                      readonly
                    />
                    <button
                      matPrefix
                      mat-icon-button
                      color="primary"
                      [disabled]="!pkg.storageGroupId"
                      (click)="onNavigateToStorageGroup(pkg.storageGroupId)"
                    >
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.orderReference' | translate }}</mat-label>
                    <input
                      matInput
                      name="orderReferenceNumber"
                      required
                      [ngModel]="pkg.orderReferenceNumber"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'packages.confirmationState.title' | translate }}</mat-label>
                    <elder-select
                      appPackageStateSelect
                      name="confirmationState"
                      readonly
                      valueAsId
                      [(ngModel)]="pkg.confirmationState"
                    >
                    </elder-select>
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.description' | translate }}</mat-label>
                    <input matInput name="description" readonly [(ngModel)]="pkg.description" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div>
              <elder-pane-subtitle>{{ 'context.characteristics' | translate }}</elder-pane-subtitle>
              <div class="layout-col gap-md">
                <div class="layout-row gap-md">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'packages.contentDescription' | translate }}</mat-label>
                    <input
                      matInput
                      name="contentDescription"
                      readonly
                      [(ngModel)]="pkg.contentDescription"
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.weight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="weight"
                      readonly
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.weight"
                    >
                    </elder-quantity-input>
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.packagingWeight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="packagingMaterialWeight"
                      readonly
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.packagingMaterialWeight"
                    >
                    </elder-quantity-input>
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.contentWeight' | translate }}</mat-label>
                    <elder-quantity-input
                      name="contentWeight"
                      readonly
                      [displayFormat]="'0.0-2'"
                      [(ngModel)]="pkg.contentWeight"
                    >
                    </elder-quantity-input>
                  </mat-form-field>
                </div>
                <div class="layout-row gap-md">
                  <mat-form-field floatLabel="always">
                    <mat-label>{{ 'context.longestItemDimensions' | translate }}</mat-label>
                    <elder-dimensions-input
                      name="longestItemDimensions"
                      readonly
                      [(ngModel)]="pkg.longestItemDimensions"
                    >
                    </elder-dimensions-input>
                  </mat-form-field>
                  <mat-form-field floatLabel="always">
                    <mat-label>{{ 'dimensions.title' | translate }}</mat-label>
                    <elder-dimensions-input name="dimensions" readonly [(ngModel)]="pkg.dimensions">
                    </elder-dimensions-input>
                  </mat-form-field>
                </div>
                <elder-audited-entity [audited]="pkg"></elder-audited-entity>
              </div>
            </div>
          </elder-pane-content>
        </elder-pane>
        <elder-pane>
          <elder-pane-header>
            <elder-pane-title>{{ 'storage.storage' | translate }}</elder-pane-title>
          </elder-pane-header>
          <elder-pane-content>
            <elder-pane-subtitle>{{ 'storage.currentLocation' | translate }}</elder-pane-subtitle>
            <div class="layout-row place-start-center gap-sm">
              <mat-form-field floatLabel="always">
                <mat-label>{{ 'storage.location' | translate }}</mat-label>
                <input
                  matInput
                  name="storagePath"
                  readonly
                  placeholder="-"
                  [ngModel]="pkg.location?.storagePath"
                />
                <mat-hint>{{ pkg.location?.checkIn | date: 'medium' }}</mat-hint>
              </mat-form-field>
              <button mat-flat-button color="primary" (click)="onMove()">
                {{ 'actions.assign' | translate }}
              </button>
              <button
                mat-flat-button
                color="primary"
                [disabled]="!canCheckout()"
                (click)="onRequestCheckout()"
              >
                {{ 'actions.checkout' | translate }}
              </button>
            </div>
            <elder-pane-subtitle>{{ 'context.history' | translate }}</elder-pane-subtitle>
            <elder-table class="flex" [data]="data" [idField]="'checkIn'" matSort>
              <!-- location Column -->
              <ng-container matColumnDef="storagePath">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'storage.location' | translate }}
                </th>
                <td mat-cell *matCellDef="let pkgLocation">
                  <div class="layout-col">
                    <span>{{ pkgLocation.storagePath }}</span>
                  </div>
                </td>
              </ng-container>
              <!-- checkin Column -->
              <ng-container matColumnDef="checkIn">
                <th mat-header-cell *matHeaderCellDef style="width: 35%" mat-sort-header>
                  {{ 'storage.checkinTimestamp' | translate }}
                </th>
                <td mat-cell *matCellDef="let pkgLocation">
                  {{ pkgLocation.checkIn | date: 'medium' }}
                </td>
              </ng-container>
              <!-- checkOut Column -->
              <ng-container matColumnDef="checkout">
                <th mat-header-cell *matHeaderCellDef style="width: 35%">
                  {{ 'storage.checkoutTimestamp' | translate }}
                </th>
                <td mat-cell *matCellDef="let pkgLocation">
                  {{ (pkgLocation.checkout | date: 'medium') || '-' }}
                </td>
              </ng-container>
            </elder-table>
          </elder-pane-content>
        </elder-pane>
      </elder-basic-pane-layout>
    </form>
  </div>
}

<ng-template #header let-pkg="pkg" let-frm="frm">
  <elder-header
    [header]="('packages.title' | translate) + ' ' + pkg.number"
    [subheader]="'ID: ' + pkg.id"
  >
  </elder-header>

  <span class="flex"></span>

  <button mat-icon-button [disabled]="!frm.form.valid" (click)="onSave($event)">
    <mat-icon>save</mat-icon>
  </button>

  <button mat-icon-button disabled [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menu="matMenu"> </mat-menu>
</ng-template>
